import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, Modal, Popover } from '@treams/treams-ui';

import MomentTemplateEditor from './MomentTemplateEditor';

export default function MomentTemplateModal({
	url,
	name,
	returnURL,
}: {
	url: string;
	name: string;
	returnURL: string;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('common.settings.momentTemplates.edit.title')}
					closeLink={returnURL}
				/>
				<Modal.Contents>
					<MomentTemplateEditor url={url} returnURL={returnURL} name={name} />
				</Modal.Contents>

				<Modal.Footer>
					<Button
						type="primary"
						role="button"
						aria-label={t('common.done')}
						title={t('common.done')}
						onClick={() => {
							history.push(returnURL);
						}}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
